import { render, staticRenderFns } from "./tab-1.vue?vue&type=template&id=2d35fd59"
import script from "./tab-1.vue?vue&type=script&lang=js"
export * from "./tab-1.vue?vue&type=script&lang=js"
import style0 from "./tab-1.vue?vue&type=style&index=0&id=2d35fd59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports